import React from 'react'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    Chip,
    Card,
    Divider,
} from '@mui/material'
import { IfOfferUpdateResult } from './types'
import { ExpandMore } from '@mui/icons-material'

type Props = {
    results: IfOfferUpdateResult[]
}

export const IfOfferResultsList: React.FC<Props> = ({ results }) => {
    if (!results.length) {
        return (
            <Typography color="text.secondary" sx={{ p: 2 }}>
                No results to display
            </Typography>
        )
    }
    return (
        <List sx={{ p: 0 }}>
            {results.map((item, index) => {
                // ✅ SUCCESS → simple list row
                if (item.success) {
                    return (
                        <Card key={item.vin}>
                            <ListItem
                                sx={{
                                    p: 2,
                                }}
                            >
                                <ListItemText
                                    primary={
                                        <>
                                            <Typography fontWeight={600}>Stock #{item.stockNumber}</Typography>
                                            <Typography variant="body2">VIN: {item.vin}</Typography>
                                        </>
                                    }
                                    secondary={
                                        <>
                                            <Typography variant="body2">{item.amsStatusText}</Typography>
                                            <Chip label="Success" color="success" size="small" sx={{ mt: 1 }} />
                                        </>
                                    }
                                />
                            </ListItem>
                        </Card>
                    )
                }

                return (
                    <Accordion
                        sx={{
                            borderRadius: '0px !important',
                            '&:before': { display: 'none' },
                        }}
                        key={item.vin}
                    >
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <Box>
                                <Typography fontWeight={600}>Stock #{item.stockNumber}</Typography>

                                <Typography variant="body2">VIN: {item.vin}</Typography>

                                <Typography variant="body2">{item.amsStatusText}</Typography>
                                <Chip label="Failed" color="error" size="small" sx={{ mt: 1 }} />
                            </Box>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Divider textAlign="left">
                                <Typography>Recent Offer History (newest to oldest)</Typography>
                            </Divider>
                            {item.ifNotes?.length ? (
                                <List dense>
                                    {item.ifNotes.map((note, i) => (
                                        <ListItem key={i} alignItems="flex-start">
                                            <ListItemText
                                                primary={<Typography>{note.note}</Typography>}
                                                secondary={
                                                    <Typography variant="caption">
                                                        {note.user} • {new Date(note.date).toLocaleString()}
                                                    </Typography>
                                                }
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            ) : (
                                <Typography color="text.secondary" variant="body2">
                                    No notes available
                                </Typography>
                            )}
                        </AccordionDetails>
                    </Accordion>
                )
            })}
        </List>
    )
}
